import {AgendaSidebar} from '@/features/agenda/components/agenda-sidebar/AgendaSidebar'
import {AgendaUrlParams} from '@/features/agenda/types'
import {useOutletContext} from 'react-router-dom'
import {AgendaUserSidebar} from '@/features/agenda/components/agenda-user-sidebar/AgendaUserSidebar'
import {AgendaPatientSidebar} from '@/features/agenda/components/agenda-patient-sidebar/AgendaPatientSidebar'
import {StyledAgendaCalendarWrapper, StyledLoadingAgendaContainer} from './style'
import {useAgendaEvents} from '@/features/agenda/hooks/useAgendaEvents'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {AgendaCalendar} from '@/features/agenda/components/agenda-calendar/AgendaCalendar'
import {useAuthStore} from '@/features/auth/store/store'
import {AgendaPageWrapper} from '@/features/agenda/components/agenda-page-wrapper/AgendaPageWrapper'
import {AgendaPageLoader} from '@/features/agenda/components/agenda-page-loader/AgendaPageLoader'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n'
import {useAgendaCalendarStore} from '@/features/agenda/stores/agendaCalendarStore'
import {useEffect} from 'react'

export const Agenda = () => {
    const {t} = useTranslation()
    const {date, entity, view} = useOutletContext<AgendaUrlParams>()
    const {user} = useAuthStore()
    const setStatusFilter = useAgendaCalendarStore(state => state.setStatusFilter)

    const {
        appointments,
        blockouts,
        unavailabilities,
        isLoading: isAgendaEventsLoading
    } = useAgendaEvents({
        date,
        view,
        entity
    })

    // reset status filter when component unmounts
    useEffect(() => {
        return () => setStatusFilter(null)
    }, [])

    if (!date || !view || !entity || !user) {
        return <AgendaPageLoader />
    }

    return (
        <AgendaPageWrapper>
            <Helmet title={t('agenda:meta_title')} />
            <AgendaSidebar>{entity == 'users' ? <AgendaUserSidebar /> : <AgendaPatientSidebar />}</AgendaSidebar>
            <StyledAgendaCalendarWrapper>
                {isAgendaEventsLoading && (
                    <StyledLoadingAgendaContainer fullHeight fullWidth>
                        <Spinner size={32} />
                    </StyledLoadingAgendaContainer>
                )}

                <AgendaCalendar
                    appointments={appointments}
                    blockouts={blockouts}
                    unavailabilities={unavailabilities}
                    date={date}
                    view={view}
                />
            </StyledAgendaCalendarWrapper>
        </AgendaPageWrapper>
    )
}
